import { render, staticRenderFns } from "./IndividualWordEditor.vue?vue&type=template&id=504f23ee"
import script from "./IndividualWordEditor.vue?vue&type=script&lang=js"
export * from "./IndividualWordEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports